import { Component, DestroyRef, OnInit, QueryList, ViewChildren, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, SelectItem } from 'primeng/api';
import { MultiSelect, MultiSelectChangeEvent } from 'primeng/multiselect';
import { MotorAndModelYearGrouping } from '../../models/motor-and-model-year-grouping/motor-and-model-year-grouping';
import { PlanSelection } from '../../models/plan-selection/plan-selection';
import { Product } from '../../models/product/product';
import { VinValidate } from '../../models/vin-validate/vin-validate';
import { ApsPermissionService } from '../../services/aps-permission/aps-permission.service';
import { MessageExceptionService } from '../../services/message-exception/message-exception.service';
import { PlanSelecionService } from '../../services/plan-selection/plan-selection.service';
import { ProductService } from '../../services/product/product.service';
import { VinValidateService } from '../../services/vin-validate-service/vin-validate-service.service';

@Component({
    selector: 'app-plan-selection',
    templateUrl: './plan-selection.component.html',
    standalone: false
})
export class PlanSelectionComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	@ViewChildren(MultiSelect) multiSelectComponents!: QueryList<MultiSelect>;

	vinValidateList: VinValidate[] = [];
	planSelectionList: PlanSelection[] = [];
	selectProducts: SelectItem[] = [];
	products: Product[] = [];
	private readonly multiSelectPanelCloseDelayMs = 4000;
	private readonly multiSelectCloseTimers = new WeakMap<MultiSelect, ReturnType<typeof setTimeout>>();

	constructor(private vinValidateService: VinValidateService,
		private planSelecionService: PlanSelecionService,
		private translateService: TranslateService,
		private messageService: MessageService,
		private productService: ProductService,
		private router: Router,
		private apsPermissionService: ApsPermissionService,
		private messageExceptionService: MessageExceptionService) {
	}

	ngOnInit() {
		this.vinValidateList = this.vinValidateService.getAllVinValidateList();

		if (this.vinValidateList.length <= 0) {
			this.router.navigate(['direct-sale']);
		}

		this.getplanSelecion();
		this.getProducts();
	}

	getplanSelecion() {
		this.planSelecionService.getPlanSelection(this.vinValidateList)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((response: PlanSelection[]) => {
				this.planSelectionList = response;
			}, (err) => {
				this.messageExceptionService.getMessageException(err.status, 'Sem acesso, por gentileza, fecha a página e faça o login novamente!');
			});
	}

	getProducts() {
		this.productService.getProducts()
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((products: Product[]) => {
				this.products = products;

				products.forEach(product => {
					this.selectProducts.push({ label: product.name, value: product.id });
				});
			});
	}

	getSelectedProducts(_event: MultiSelectChangeEvent, motorAndModelYearGrouping: MotorAndModelYearGrouping) {

		let unitPrice = 0;
		for (const planItem of motorAndModelYearGrouping.plan) {
			unitPrice = unitPrice + this.getPriceProduct(planItem);
		}

		motorAndModelYearGrouping.unitPrice = unitPrice;
		motorAndModelYearGrouping.totalPrice = unitPrice * motorAndModelYearGrouping.qtd;
	}

	scheduleMultiSelectPanelClose(multiSelect: MultiSelect) {
		if (!multiSelect) {
			return;
		}

		this.cancelMultiSelectPanelClose(multiSelect);

		const timeoutId = setTimeout(() => {
			if (multiSelect && multiSelect.overlayVisible && typeof multiSelect.hide === 'function') {
				multiSelect.hide();
			}
			this.multiSelectCloseTimers.delete(multiSelect);
		}, this.multiSelectPanelCloseDelayMs);

		this.multiSelectCloseTimers.set(multiSelect, timeoutId);
	}

	cancelMultiSelectPanelClose(multiSelect: MultiSelect) {
		if (!multiSelect) {
			return;
		}

		const timeoutId = this.multiSelectCloseTimers.get(multiSelect);

		if (timeoutId) {
			clearTimeout(timeoutId);
			this.multiSelectCloseTimers.delete(multiSelect);
		}
	}

	getPriceProduct(value: string | number): number {
		const productId = Number(value);

		for (const product of this.products) {
			if (product.id === productId) {
				return product.customerPrice ?? 0;
			}
		}

		return 0;
	}

	getNameProduct(value: number): string {

		for (const product of this.products) {

			if (product.id === value) {
				return product.name;
			}
		}

		return '';
	}

	buttonPlan() {
		this.planSelectionList.forEach(planSelection => {
			planSelection.motorAndModelYearGrouping.forEach(motorAndModelYearGrouping => {
				motorAndModelYearGrouping.plan = '';
				motorAndModelYearGrouping.totalPrice = 0;
				motorAndModelYearGrouping.unitPrice = 0;
			})
		});
		this.resetMultiSelectFilters();
	}

	private resetMultiSelectFilters(): void {
		if (!this.multiSelectComponents) {
			return;
		}

		this.multiSelectComponents.forEach((multiSelect) => {
			const multiSelectWithFilter = multiSelect as MultiSelect & {
				resetFilter?: () => void;
				filterValue?: string | null;
			};

			multiSelectWithFilter.resetFilter?.();

			if ('filterValue' in multiSelectWithFilter) {
				multiSelectWithFilter.filterValue = null;
			}
		});
	}

	buttonComeBack() {
		this.router.navigate(['direct-sale']);
	}

	buttonNextWindow() {
		let isValid = true;

		this.planSelectionList.forEach(planSelection => {
			planSelection.motorAndModelYearGrouping.forEach(motorAndModelYearGrouping => {
				if (motorAndModelYearGrouping.plan === null || motorAndModelYearGrouping.plan.length <= 0) {
					isValid = false;
				}
			})
		});

		if (isValid) {
			this.planSelecionService.setAllPlanSelectionList(this.planSelectionList);
			this.router.navigate(['customer']);
		} else {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Selecionar plano para o veículo.' });
		}
	}

}
